export default __webpack_public_path__ + "static/media/roadmap-banner-sky.97cf25b6.svg";